import { render, staticRenderFns } from "./shopDecorate.vue?vue&type=template&id=198f73da&scoped=true"
import script from "./shopDecorate.vue?vue&type=script&lang=js"
export * from "./shopDecorate.vue?vue&type=script&lang=js"
import style0 from "./shopDecorate.vue?vue&type=style&index=0&id=198f73da&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198f73da",
  null
  
)

export default component.exports